import React, { useMemo, memo } from 'react'
import injectSheet from 'react-jss'
import styles from './slide.styles'
import Slide from '../../../components/slide/slide.jsx'
import { format } from 'date-fns'
import { usePresentationPattern } from 'pobble-components/dist/presentation-utils'
import {
  usePresentation,
  withPresentation
} from '../../../presentation-connectors'

const TitleSlide = memo(({ classes, slides, id }) => {
  const data = slides[id]

  const presentation = usePresentation()

  const pattern = usePresentationPattern(presentation.pattern)

  const yearRange = useMemo(() => {
    return `${presentation.yearGroups[0].from} – ${
      presentation.yearGroups[presentation.yearGroups.length - 1].to
    }`
  }, [presentation.yearGroups])

  const slideData = useMemo(
    () => ({
      title: data.title,
      date: format(new Date(), 'DD MMMM YYYY'),
      image: data.image && data.image.url
    }),
    [data]
  )

  const containerStyle = useMemo(() => {
    return slideData.image
      ? {
          backgroundImage: `url("${slideData.image}")`
        }
      : {
          backgroundImage: `url("${pattern.pattern}")`,
          backgroundColor: pattern.color
        }
  }, [slideData.image, pattern])

  return (
    <Slide className={classes.container} style={containerStyle}>
      <div className={classes.textHolder}>
        {!presentation.allYearGroups && presentation.showAge && (
          <div className={classes.yearRange}>Age {yearRange}</div>
        )}
        <p className={classes.title}>
          <span className={classes.titleTextHolder}>
            <span className={classes.titleText}>{slideData.title}</span>
          </span>
        </p>
        <div className={classes.dateWrapper}>
          <p className={classes.date}>{slideData.date}</p>
        </div>
      </div>
    </Slide>
  )
})

export default withPresentation(injectSheet(styles)(TitleSlide))
